import { useAutocompleteSource } from '@eas/common-web';
import { DictSubmissionContentAutocomplete } from '@models';
import { EvidenceApiUrl } from '@enums';

export function useSubmissionContents() {
  return useAutocompleteSource<DictSubmissionContentAutocomplete>({
    url: `${EvidenceApiUrl.DICT_SUBMISSION_CONTENTS}/autocomplete`,
  });
}
